import { TrendingUp, TrendingDown } from "lucide-react";
import { cn } from "@/lib/utils";

export function KPITile({ label, value, hint, trend, icon: Icon, accent = "default", testId }) {
  const accentMap = {
    default: "text-zinc-950",
    green: "text-emerald-700",
    amber: "text-amber-700",
    red: "text-red-700",
    blue: "text-blue-700",
  };
  return (
    <div
      data-testid={testId}
      className="bg-white border border-zinc-200 rounded-md p-5 shadow-sm hover:shadow-md transition-shadow duration-200"
    >
      <div className="flex items-start justify-between">
        <p className="text-xs font-semibold tracking-[0.1em] uppercase text-zinc-500">{label}</p>
        {Icon && <Icon className="h-4 w-4 text-zinc-400" />}
      </div>
      <div className={cn("mt-3 text-4xl font-black tracking-tighter font-display", accentMap[accent])}>{value}</div>
      {(hint || trend !== undefined) && (
        <div className="mt-2 flex items-center gap-2 text-xs text-zinc-500">
          {trend !== undefined && (
            <span className={cn("inline-flex items-center gap-1 font-medium", trend >= 0 ? "text-emerald-700" : "text-red-700")}>
              {trend >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
              {Math.abs(trend)}%
            </span>
          )}
          {hint && <span>{hint}</span>}
        </div>
      )}
    </div>
  );
}

export default KPITile;
